import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useAccount } from '../../../app/account-context';
import SvgArrowRight from '../../../assets/icons/ArrowRight';
import { T, translate } from '../../../components/basic/text';
import { FormikTextField } from '../../../components/formik/formik-text-field';
import { SectionTitle } from '../../../components/ui/section-title';
import { TProvider } from '../../../i18n';
import { notify } from '../../../components/basic/notify';
import { CSSProperties } from 'react';
export const RegisterApp = () => {
    const navigate = useNavigate();
    const account = useAccount();

    const submitRegister = (values: any) =>
        account
            .register(
                values.firstname,
                values.lastname,
                values.userName,
                values.password,
                values.confirmpassword
            )
            .then(() => navigate('/home'))
            .catch(err => notify.error(translate(err)));

    const parent_style: CSSProperties = { maxWidth: 500 };
    const child_style: CSSProperties = { maxWidth: 500, borderRadius: 9 };
    const initialValues = {
        userName: '',
        firstname: '',
        lastname: '',
        confirmpassword: '',
        password: '',
    };
    return (
        <TProvider>
            <div className="container-fluid pb-6  mt-5" style={parent_style}>
                <bd.Paper className="mx-auto border shadow-3 overflow-hidden" style={child_style}>
                    <SectionTitle
                        title="register"
                        className="p-3 mb-3 h-auto bg-shell"
                        titleTextColor="text-white"
                    />

                    <Formik
                        initialValues={initialValues}
                        validationSchema={yup.object({
                            userName: yup.string().required(' '),
                            password: yup.string().required(' '),
                            confirmpassword: yup.string().required(' '),
                        })}
                        onSubmit={submitRegister}
                    >
                        {formik => (
                            <Form>
                                <div className="px-3 pb-3">
                                    <FormikTextField
                                        labelWidth={4}
                                        label="first-name"
                                        name="firstname"
                                        maxLength={50}
                                        autoFocus
                                        handleEnter
                                    />
                                    <FormikTextField
                                        labelWidth={4}
                                        label="last-name"
                                        name="lastname"
                                        maxLength={50}
                                        handleEnter
                                    />
                                    <FormikTextField
                                        label={<T>user-name</T>}
                                        name="userName"
                                        labelWidth={4}
                                        inputClassName="ltr"
                                        maxLength={50}
                                        handleEnter
                                    />
                                    <FormikTextField
                                        labelWidth={4}
                                        label="password"
                                        name="password"
                                        autoComplete="off"
                                        maxLength={50}
                                        inputClassName="ltr"
                                        type="password"
                                        handleEnter
                                    />
                                    <FormikTextField
                                        labelWidth={4}
                                        label="confirm-password"
                                        name="confirmpassword"
                                        autoComplete="off"
                                        maxLength={50}
                                        inputClassName="ltr"
                                        type="password"
                                        handleEnter
                                    />

                                    <div className="p-e-4 mt-4 text-end">
                                        <bd.Button
                                            isValid={formik.isValid}
                                            variant="contained"
                                            type="submit"
                                        >
                                            <T>continue</T>
                                        </bd.Button>
                                    </div>
                                </div>
                                <bd.Flex
                                    className="p-3 border-top small"
                                    align="start"
                                    gap={2}
                                    vertical
                                >
                                    <Link className="text-link" to="/login">
                                        <SvgArrowRight className="rtl-rotate-180" /> <T>login</T>
                                    </Link>
                                </bd.Flex>
                            </Form>
                        )}
                    </Formik>
                </bd.Paper>
            </div>
        </TProvider>
    );
};
